import { PreferencesType } from "../../types/account/type";
import { loadFromLocalStorage, saveToLocalStorage } from "../../utils/localStorage/localStorage";

export const PREFERENCE_KEY = "userPreference";

/**
 * 로컬스토리지의 값을 가져오기만 하는 역할
 * @param allSpaceIds
 * @returns
 */

export const getLocalPreference = (): PreferencesType => {
  const newUserPreferenceLocal = loadFromLocalStorage<PreferencesType>(PREFERENCE_KEY);
  return newUserPreferenceLocal as PreferencesType;
};

/**
 * 로컬스토리지에 저장만 하는 역할
 * @param pref
 */

export const setLocalPreference = (pref: PreferencesType) => {
  saveToLocalStorage(PREFERENCE_KEY, pref);
};
